import { render, staticRenderFns } from "./WiseAccount.vue?vue&type=template&id=02aced8d&"
import script from "./WiseAccount.vue?vue&type=script&lang=js&"
export * from "./WiseAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports